import { ApplicationRef, ComponentRef, Injectable, ViewContainerRef, inject } from '@angular/core';
import { InstallAppsBannerComponent } from 'mbs-ui-shared@components/install-apps-modal/install-apps-banner.component';
import { AuthFacade } from 'mbs-ui-shared@facades/auth.facade';
import { AppPersistentStateService } from 'mbs-ui-shared@services/app-persistent-state.service';

@Injectable({
  providedIn: 'root'
})
export class MobileApplicationsService {
  private appRef = inject(ApplicationRef);
  private appPersistentState = inject(AppPersistentStateService);
  authFacade = inject(AuthFacade);

  private componentRef: ComponentRef<InstallAppsBannerComponent>;

  public showInstallBanner(container: ViewContainerRef) {
    // This property set in mbs-web index.html
    const installPrompt = (window as any).installPrompt;

    const isShowBanner =
      Boolean(installPrompt) &&
      (navigator as any)?.userAgentData?.mobile &&
      this.appPersistentState.data.showApplicationInstallBanner &&
      !this.authFacade.currentUserValue?.BrandingSetting?.BrandingActivated;

    if (!isShowBanner) return;

    this.componentRef = container.createComponent(InstallAppsBannerComponent, {
      environmentInjector: this.appRef.injector
    });

    this.componentRef.instance.installPrompt = installPrompt;
  }

  public hideInstallBanner() {
    this.componentRef.destroy();
  }
}
